import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-product-service',
  templateUrl: './create-product-service.component.html',
  styleUrls: ['./create-product-service.component.scss']
})
export class CreateProductServiceComponent implements OnInit {
  @Input() productInfo: any;

  constructor(
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
  }


  sendData(): any {
    const dataToSend = {...this.productInfo};
    this.activeModal.close(dataToSend);
  }

  createLinkFields() {
    this.productInfo.productServicesItems.push({
      item: '',
      url: '',
      orderId: this.productInfo.productServicesItems.length + 1,
      columnId: this.productInfo.column
    });
  }


  deleteLinkField(i: number): any {
    if (this.productInfo.productServicesItems.length > 1) {
      this.productInfo.productServicesItems.splice(i, 1);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'No puedes eliminar el primer link!',
      });
    }
  }

  validateEmptyFields(): any {
    if (!this.productInfo.title ||
      this.productInfo.productServicesItems.filter(x => !x.item).length ||
      this.productInfo.productServicesItems.filter(x => !x.url).length
    ) {
      return false;
    } else {
      return true;
    }
  }

  checkExistingName(): any {
    const validators = [];
    this.productInfo.all.forEach(item => {
      item.detail.forEach(child => {
        validators.push(child.title);
      });
    });
    const checkExistingName = (arr, val) => {
      return arr.some(arrVal => {
        return val.toLowerCase().trim() === arrVal.toLowerCase().trim();
      });
    };
    return checkExistingName(validators, this.productInfo.title);
  }
}
